import Router from 'vue-routes-generator'
import Main from './Main'
import Mapa from './components/mapa/mapa'
export default {
	install: () => {
		Router.route('/main').child('control-emisoras', {
			name: 'Control de emisoras',
			component: Main
		})

		Router.route('/main').child('control-emisoras').child('mapa', {
			name: 'Mapa de cobertura',
			component: Mapa
		})

		Router.route('/main').child('control-emisoras').child('', {
			name: 'Registros de control de emisoras',
			component: Mapa
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/control-emisoras/vue/index.js